import { Fragment, useState } from 'react'

import { ContentPage_content_PdfContent } from 'globalTypes'
import { Document, Page, pdfjs } from 'react-pdf'
import { useResizeDetector } from 'react-resize-detector'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import List from 'Root/App/Tag/List'
import Title from 'Root/App/Title'
import Loader from 'Root/Loader'
import BottomContent from 'Root/Pages/Content/Component/BottomContent'
import { PDF_CONTENT_SCROLL_NAVIGATION_PAGES_THRESHOLD } from 'lib/constants'
import { secondsToDuration } from 'lib/seconds-to-duration'
import filter from 'lodash/filter'
import join from 'lodash/join'

import styles from './index.module.css'
import PdfSinglePageNavigation from './pdf-single-page-nav'

library.add(faArrowLeft, faArrowRight)

interface Props {
  content: ContentPage_content_PdfContent
}

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

const DefaultStatus = ({ content }: Props) => {
  const { width, ref } = useResizeDetector()
  const [pageCount, setPageCount] = useState(content?.pdfDetails?.pages)
  const [pageNumber, setPageNumber] = useState(1)

  const onLoadSuccess = ({ numPages }) => {
    setPageCount(numPages)
  }

  const ert = content.duration || 0

  const pdfContentDetails = filter([
    content.label,
    pageCount ? `${pageCount} pp` : null,
    Boolean(ert && ert >= 60) ? secondsToDuration(ert) : null,
  ])

  const renderSinglePage =
    pageCount && pageCount > PDF_CONTENT_SCROLL_NAVIGATION_PAGES_THRESHOLD

  const ReactPdfDocument: any = Document
  const ReactPdfPage: any = Page

  return (
    <Fragment>
      {pageNumber === 1 && (
        <>
          <div className="p-6 flex flex-col gap-y-3">
            <PreTitle className="-mb-1">
              {join(pdfContentDetails, ' · ')}
            </PreTitle>
            <Title size="M">{content.title}</Title>
            <Paragraph size="L">{content.description}</Paragraph>
            <List tags={content.tags} />
            <BottomContent content={content} />
          </div>
        </>
      )}

      <div id="pdf-document" ref={ref}>
        <ReactPdfDocument
          className={styles.document}
          externalLinkTarget="_blank"
          file={content.url}
          onLoadSuccess={onLoadSuccess}
          loading={
            <div className="p-5">
              <Loader className="h-6 w-6 mx-auto" />
            </div>
          }
        >
          {renderSinglePage ? (
            <div className={styles.page}>
              <ReactPdfPage pageNumber={pageNumber} width={width} />
            </div>
          ) : (
            Array.from(new Array(pageCount), (_el, index) => (
              <div className={styles.page} key={`page_${index + 1}`}>
                <ReactPdfPage pageNumber={index + 1} width={width} />
              </div>
            ))
          )}
        </ReactPdfDocument>

        {renderSinglePage && (
          <PdfSinglePageNavigation
            pageNumber={pageNumber}
            pageCount={pageCount}
            setPageNumberCallback={setPageNumber}
          />
        )}
      </div>
    </Fragment>
  )
}

export default DefaultStatus
